export default __webpack_public_path__ + "static/single-leave-03-be23979b26b408cbd956e0715ed8a993.png";